import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=199d98c4&scoped=true&"
import script from "./ProductsTable.vue?vue&type=script&lang=ts&"
export * from "./ProductsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsTable.vue?vue&type=style&index=0&id=199d98c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199d98c4",
  null
  
)

export default component.exports